<template>
  <splash/>
  <div class="container mt-4" dir="rtl">
  <sidebar/>
    <div class="card-panel-main col-lg-9 mb-5 p-4" style="transform: translateX(-19vw)">

      <financial_information :units="[...all]"/>
      <received_information :units="[...all]" />
      <outcome_information :units="[...all]" />
      <effect_information :units="[...all]" />

    </div>
  </div>
</template>
<script  >
import Splash from "@/components/Splash/Splash.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import financial_information from "@/components/Financial_management_and_productivity/basic/financial_information.vue";
import Received_information from "@/components/Financial_management_and_productivity/basic/Received_information.vue";
import Outcome_information from "@/components/Financial_management_and_productivity/basic/Outcome_information.vue";
import Effect_information from "@/components/Financial_management_and_productivity/basic/Effect_information.vue";
import router from "@/router";

export  default {
  components: {Effect_information, Outcome_information, Received_information, Sidebar, Splash,financial_information},
  data(){
    return{
      all:[]
    }
  },
  methods:{
    fetchAll(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/units/all`, requestOptions)
          .then(response => response.json())
          .then(response => {
          response.all.forEach((item)=>{
            this.all.push(item)
          })



          })
          .catch();
    },
    checkIsMother(){
      if (this.is_mother){
        router.push('/mother_items')
      }

    }
  },
  mounted() {
    this.fetchAll()
    this.checkIsMother()
  }

}

</script>

<style scoped>

</style>